export default
{
    formData(formElement)
    {
        const elements = formElement.querySelectorAll('[name]');
        const formData = {};

        for(let i = 0, n = elements.length; i < n; i++)
        {
            const el = elements[i];
    
            if(el.checked || !['radio', 'checkbox'].includes(el.type))
            {
                formData[el.name] = el.value;
            }
        }

        return formData;
    }
}